import { motion } from 'framer-motion';

/**
 * AnimatedLogo - Animated logo using Framer Motion
 * Perfect alternative to Lottie if you want to animate your existing PNG logo
 */
export default function AnimatedLogo({ 
  src = "/logo-new.png", 
  alt = "HealthQ",
  className = "h-10 w-auto",
  animationType = "gentle" // 'gentle', 'pulse', 'float', 'spin'
}) {
  const animations = {
    gentle: {
      scale: [1, 1.05, 1],
      transition: {
        duration: 3,
        repeat: Infinity,
        ease: "easeInOut"
      }
    },
    pulse: {
      scale: [1, 1.1, 1],
      opacity: [1, 0.9, 1],
      transition: {
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut"
      }
    },
    float: {
      y: [0, -10, 0],
      rotate: [0, 2, -2, 0],
      transition: {
        duration: 4,
        repeat: Infinity,
        ease: "easeInOut"
      }
    },
    spin: {
      rotate: [0, 360],
      transition: {
        duration: 20,
        repeat: Infinity,
        ease: "linear"
      }
    }
  };

  return (
    <motion.img
      src={src}
      alt={alt}
      className={className}
      animate={animations[animationType]}
      whileHover={{ scale: 1.1 }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
    />
  );
}
